module.exports = __webpack_public_path__ + "assets/img/itemCardBodyBk1.e9cb52a6.png";